import React from 'react';
import _, { range } from 'lodash';
import TrimSpec from './trims/TrimSpec';
import useModelsData from './data-caches/useModelsData';
import useContextValidator from './data-caches/useContextValidator';

function groupIdenticalContextsByYearRanges(contexts) {
  contexts = _.groupBy(contexts, ({year, _source, ... ctx}) => JSON.stringify(ctx));

  return _.map(contexts, (ctxList) => {
    if(ctxList.length > 1) {
      let years =  _.compact(ctxList.map(ctx => Number(ctx.year))).sort();
      let ranges = [];
      let lastYear;
      let currentRange;
      for(let year of years) {
        if(year === lastYear + 1) {
          currentRange.push(year);
        } else {
          currentRange &&ranges.push(currentRange);
          currentRange = [year];
        }
        lastYear = year;
      }

      if(currentRange?.length) {
        ranges.push(currentRange);
      }

      let rangesText = ranges.flatMap((range) => {
        if(range.length > 2) {
          return [`${range[0]} ... ${range[range.length - 1]}`];
        } else if(range.length === 2) {
          return [`${range[0]}-${range[1]}`];
        } else {
          return range;
        }
      });

      return {... ctxList[0], year: rangesText};
    } else {
      return ctxList[0];
    }
  })
}

function LegoContextSpan({ context, locale, inline = false, limit = 8, wrap = true, ... props }) {
  const [isValid, explanation] = useContextValidator(context, locale);
  const specsPairs = [];
    let contextCopy = { ...context };

    let baseContext = [];
    ['make', 'modelId'].forEach(filter => {
      let filterValue = contextCopy[filter];
      if (filterValue) {
        baseContext.push(filterValue);
        delete contextCopy[filter];
      }
    });

    if(contextCopy.trimSpecs) {
      contextCopy = {... contextCopy, ... contextCopy.trimSpecs};
      delete contextCopy.trimSpecs;
    }

    let generated = false;
    if(contextCopy.runId) {
      delete contextCopy.runId;
      generated = true;
    }

    if (context.year) {
      if (_.isArray(context.year)) {
        _.each(context.year, (range) => {
          specsPairs.push(<TrimSpec key={range} showSpec={false} spec={'year'} value={range} className={'mr-1'} />);
        });
      } else {
        specsPairs.push(<TrimSpec key={context.year} showSpec={false} spec={'year'} value={context.year} className={'mr-1'} />);
      }
      delete contextCopy.year;
    }

    _.each(contextCopy, (val, key) => {
      let hideBaseGen = false;
      if(key === 'genId' && context.modelId && val.startsWith('@'+context.modelId+'@')) {
        hideBaseGen = true;
      }
      return specsPairs.push(<TrimSpec hideBaseGen={hideBaseGen} key={key} showSpec={true} spec={key} value={val} className={'mr-1'}/>);
    });

    if (!specsPairs.length && !baseContext.length) {
      return <span key={'*'} className={'badge badge-violeta text-warning mx-1'}>✱</span>;
    } else {
      const base = baseContext.join(' ');

      return <div title={explanation || ''} className={`${wrap ? 'no-wrap' : ''} ${isValid ? '' : 'bg-light-danger border border-danger rounded'} ${inline ? 'd-inline-block mr-1' : 'mb-1 '}`}>
        { base ? <TrimSpec spec={'modelId'} value={context.modelId || base} className={'mr-1'}>
          {base}
        </TrimSpec> : null}

        {specsPairs}
      </div>;
    }
}

export default function LegoContextSummary({ context, locales = null, inline = false, limit = 8, wrap = true, ... props }) {  
  let contexts = context || [{}];
  if (!_.isArray(contexts)) {
    contexts = [contexts];
  }

  contexts = _.sortBy(contexts, ctx => ctx.make || ctx.modelId, ctx => _.keys(ctx).length);

  contexts = groupIdenticalContextsByYearRanges(contexts)

  let more = null;
  if(contexts.length > limit) {
    more = <div className={'text-secondary small'}>And {contexts.length - limit} more contexts...</div>
  }

  let contextsSpans = _.map(contexts.slice(0,limit), (context, i) => <LegoContextSpan wrap={wrap} key={i} context={context} locale={locales?.[0]} inline={inline} limit={limit} {... props} />);
  
  if(inline) {
    return <span {... props}>{contextsSpans} {more}</span>;
  } else {
    return <div {... props}>{contextsSpans} {more}</div>;
  }
}
